import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAccountBase, useCurrentAccount } from '../../account/AccountContext';
import { CallsList } from '../../components/CallsList';

/** The customer's own calls — the account home screen. A plain mobile list; a tap
 *  opens the call on its own detail page. */
export default function CustomerCallsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const base = useAccountBase();
  const { accountId } = useCurrentAccount();
  return (
    <div className="h-full overflow-y-auto px-4 pt-6 pb-24">
      <div className="mx-auto max-w-md space-y-4">
        <header>
          <h1 className="text-xl font-semibold">{t('calls.title')}</h1>
          <p className="text-sm text-muted-foreground">{t('calls.subtitle')}</p>
        </header>
        <CallsList accountId={accountId} onOpen={(id) => navigate(`${base}/calls/${id}`)} />
      </div>
    </div>
  );
}
